export default __webpack_public_path__ + "static/media/profile-connect.0aaabe68.svg";